export enum OrderTypeEnum {
  PREORDER = 'preorder',
  REORDER = 'reorder',
}
